import KPIReportPage from "./KPIReportPage";
export default KPIReportPage;